import { useTheme } from '@emotion/react';
import {
  DeleteForeverOutlined,
  FileDownloadOutlined
} from '@mui/icons-material';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import { DOWNLOAD_FILE } from 'framework/base/constants/aryRestCommands';
import useAryGetData, {
  aryGetDataExpectTypes
} from 'framework/base/hooks/useAryGetData';
import useAryLayoutType from 'framework/base/hooks/useAryLayoutType';
import {
  downloadFileInBrowser,
  getFileNameFromFileId
} from 'framework/base/utils/Utils';
import React from 'react';
import { actionIconsWrapper } from './StyledComponents';

export default function ActionButtons({
  preview,
  previews,
  files,
  prevFiles,
  propsFileIds,
  removedFileIds,
  handleRemovedFileIds,
  onChange,
  setPreviews,
  setPrevFiles,
  handleSavedFileIds,
  closeShowPreviewAfterRemoveFile,
  hideDeleteIcon,
  iconColor,
  handleSetDisabledDropzone,
  iconSize,
  ...others
}) {
  const layoutType = useAryLayoutType();
  const theme = useTheme();
  const IconStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.125rem'
  };
  const [downloadFile] = useAryGetData(DOWNLOAD_FILE, {
    expect: aryGetDataExpectTypes.file
  });
  const handleDownLoadFile = () => {
    if (handleSetDisabledDropzone) {
      handleSetDisabledDropzone(true);
    }
    if (preview.fileId) {
      downloadFile([{ key: 'fileId', value: preview.fileId }]).then(
        (downloadFileData) => {
          downloadFileInBrowser(
            downloadFileData,
            getFileNameFromFileId(preview.fileId)
          );
        }
      );
      if (handleSetDisabledDropzone) {
        handleSetDisabledDropzone(false);
      }
    } else {
      fetch(preview.imgSrc)
        .then((response) => response.blob())
        .then((blob) => {
          // Create a link element
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = preview.name; // Specify a name for the file

          // Append link to body
          document.body.appendChild(link);

          // Programmatically click the link to trigger download
          link.click();

          // Cleanup
          link.remove();
          URL.revokeObjectURL(link.href);
          handleSetDisabledDropzone(false);
        })
        .catch((error) => console.error('Error downloading the image:', error));
    }
  };
  const handleRemoveFile = () => {
    handleSetDisabledDropzone(true);
    const remainingPreviews = previews.filter(
      (obj) => obj.name !== preview.name
    );
    const remainingFiles = files.filter((obj) => obj.name !== preview.name);
    const remainingPrevFiles = prevFiles?.filter(
      (obj) => getFileNameFromFileId(obj) !== preview.name
    );
    if (propsFileIds?.includes(preview?.fileId)) {
      handleRemovedFileIds(removedFileIds.concat(preview?.fileId));
    }
    onChange(remainingFiles);
    setPreviews(remainingPreviews);
    setPrevFiles(remainingPrevFiles);
    if (handleSavedFileIds) {
      handleSavedFileIds(remainingPrevFiles);
    }
    handleSetDisabledDropzone(false);
  };
  return (
    <Box {...actionIconsWrapper} {...others.style}>
      {!hideDeleteIcon && (
        <Grid
          {...IconStyles}
          sx={{ cursor: 'pointer', ...others.iconSx }}
          onMouseUp={(e) => {
            e.stopPropagation();
            handleRemoveFile();
            if (closeShowPreviewAfterRemoveFile) {
              closeShowPreviewAfterRemoveFile(null);
            }
          }}
        >
          <DeleteForeverOutlined
            fontSize={iconSize || ''}
            style={{ color: iconColor || theme.palette.white.main }}
          />
        </Grid>
      )}
      {(preview.fileId || layoutType === 'mobile') && (
        <Grid
          {...IconStyles}
          sx={{ cursor: 'pointer', ...others.iconSx }}
          onMouseUp={(e) => {
            e.stopPropagation();
            handleDownLoadFile();
          }}
        >
          <FileDownloadOutlined
            fontSize={iconSize || ''}
            style={{ color: iconColor || theme.wrapper.background.paper }}
          />
        </Grid>
      )}
    </Box>
  );
}
